<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="loader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-row>
        <b-col
          v-for="(data,index) in moduleOptions"
          :key="index"
          style="cursor: pointer;"
          xl="2"
          md="4"
          sm="6"
          class="match-height"
          :title="`View ${data.label} Cases`"
          @click="getStuckCases(data.value)"
        >
          <statistic-card-vertical
            icon="CpuIcon"
            :statistic="data.counter"
            :statistic-title="data.label"
            color="info"
            :style="{'background-color': selectedTab === data.value ? '#219289' : ''}"
          />
        </b-col>

      </b-row>
      <b-card>
        <b-row
          v-if="[1, 3, 4, 9, 14, 'all_delayed', 'all', 'duplicate'].includes(selectedTab)"
          class="mb-1"
        >
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="button"
              variant="primary"
              class="mr-1"
              @click="resumeAllCases"
            >
              Fix All
            </b-button>
          </b-col>
        </b-row>

        <b-table
          ref="roles"
          class="position-relative"
          selectable
          :fields="tableFields"
          :items="stuckCasesData"
          :select-mode="selectMode"
          hover
          @row-selected="onRowSelected"
        >
          <template #cell(action)="data">
            <b-link
              :to="{ name: 'case-details', params: { id: data.item.id } }"
              target="_blank"
            >

              <b-dropdown
                v-if="data.item.process_module.module_id === 3 || data.item.process_module.module_id === 4 || data.item.awaited === true "
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >

                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  v-if="!data.item.repeated"
                  @click="resumeProcess(data.item.case_id, false)"
                >
                  <feather-icon icon="RefreshCcwIcon" />
                  <span class="align-middle ml-50">Resume</span>
                </b-dropdown-item>

                <b-dropdown-item
                  v-else
                  @click="resumeProcess(data.item.case_id, true)"
                >
                  <feather-icon icon="RefreshCcwIcon" />
                  <span class="align-middle ml-50">Fix</span>
                </b-dropdown-item>

              </b-dropdown>
            </b-link>
          </template>
        </b-table>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BTable, BRow, BCol, BDropdown, BDropdownItem, BButton, BLink,
} from 'bootstrap-vue'
import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BOverlay,
    BTable,
    StatisticCardVertical,
    BRow,
    BCol,
    BDropdown,
    BDropdownItem,
    BButton,
    BLink,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loader: false,
      stuckCasesData: [],
      constants,
      selectMode: 'single',
      moduleOptions: [
        { label: 'Await Module', value: 1, counter: 0 },
        { label: 'Condition Module', value: 2, counter: 0 },
        { label: 'Send Letter Module', value: 3, counter: 0 },
        { label: 'Send Email module', value: 4, counter: 0 },
        { label: 'Change State Module', value: 5, counter: 0 },
        { label: 'Action Module', value: 6, counter: 0 },
        { label: 'Fee Reminder Module', value: 7, counter: 0 },
        { label: 'Send Invoice Module', value: 8, counter: 0 },
        { label: 'User Action Module', value: 9, counter: 0 },
        { label: 'Task List Module', value: 10, counter: 0 },
        { label: 'Compensation Fee Module', value: 11, counter: 0 },
        { label: 'Collection Cost Module', value: 12, counter: 0 },
        { label: 'Collection Fee Module', value: 13, counter: 0 },
        { label: 'Timed Condition Module', value: 14, counter: 0 },
        { label: 'Custom Field Data Module', value: 15, counter: 0 },
        { label: 'Change Termsheet Module', value: 16, counter: 0 },
        { label: 'Bailiff Conclusion Module', value: 17, counter: 0 },
        { label: 'Bailiff Case Module', value: 18, counter: 0 },
        { label: 'Duplicate', value: 'duplicate', counter: 0 },
        { label: 'All Delayed', value: 'all_delayed', counter: 0 },
        { label: 'All', value: 'all', counter: 0 },
      ],
      allCounter: 0,
      selectedTab: 'all',
    }
  },
  computed: {
    tableFields() {
      const fields = [
        { key: 'case_id', sortable: true, label: i18n.t('DEBTIA_CASE') },
        { key: 'process', sortable: true, label: i18n.t('DEBTIA_PROCESSES') },
        { key: 'module', sortable: true, label: i18n.t('DEBTIA_MODULE_TEXT') },
        { key: 'delayExpected', sortable: true, label: i18n.t('DEBTIA_EXPECTED_DELAY') },
        { key: 'delayed', sortable: true, label: i18n.t('DEBTIA_DELAYED') },
        { key: 'company', sortable: true, label: i18n.t('DEBTIA_COMPANY') },
        { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ]

      if (JSON.parse(localStorage.getItem('userData')).role[0] !== 'super-admin') {
        fields.splice(5, 1)
      }

      if (this.selectedTab === 9) {
        fields.splice(5, 0, { key: 'process_module.module_user_action.recipient', sortable: true, label: 'Waiting For' })
      }
      return fields
    },
  },
  created() {
    this.getStuckCases()
  },
  methods: {
    onRowSelected(item) {
      window.open(`/cases/details/v2/${item[0].case_id}`, '_blank')
    },
    async getStuckCases(id = null) {
      try {
        this.loader = true
        this.selectedTab = id !== null ? id : 'all'
        this.stuckCasesData = []
        const cases = await axios.get(`${constants.baseUrl}/process/stuck-cases`)
        if (cases.status) {
          const idMap = this.filterDuplicates(cases.data.data)
          const repeatedObjects = []
          this.allCounter = 0

          idMap.forEach(objects => {
            if (objects.length > 1) {
              repeatedObjects.push(...objects)
            } else {
              this.stuckCasesData.push(...objects)
            }
          })
          const arr = [...this.stuckCasesData]
          this.moduleOptions.map(e => {
            e.counter = 0
            this.stuckCasesData.filter(c => {
              if (e.value === c.process_module.module_id) {
                e.counter += 1
              }
              return true
            })
            this.allCounter += e.counter
            if (e.value === 'duplicate') {
              e.counter = repeatedObjects.length
              if (id === 'duplicate') {
                this.stuckCasesData = []
                this.stuckCasesData = [...repeatedObjects]
              }
            }
            if (e.value === 'all_delayed') {
              const allDelayed = []
              arr.filter(c => {
                if (c.is_delayed === true) {
                  e.counter += 1

                  allDelayed.push(c)
                }
                return true
              })
              if (id === 'all_delayed') {
                this.stuckCasesData = []
                this.stuckCasesData = [...allDelayed]
              }
            }
            if (e.value === 'all') {
              e.counter = this.allCounter
            }
            return true
          })
          if (id !== null && id !== 'duplicate' && id !== 'all' && id !== 'all_delayed') {
            this.stuckCasesData = this.stuckCasesData.filter(e => id === e.process_module.module_id)
          }
        }
        this.loader = false
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error',
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: error,
          },
        })
      }
    },
    resumeProcess(caseID, repeated) {
      this.$swal({
        title: 'Are you sure?',
        text: 'It will resume the process.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, resume it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.loader = true
          await axios.post('/process/resume-stuck-cases', { cases: [caseID], fixRepeated: repeated })
            .then(response => {
              this.getStuckCases(this.selectedTab)
              this.$swal({
                icon: 'success',
                title: 'Process resumed, added to the queue.',
                text: response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
        }
      })
    },
    filterDuplicates(data) {
      const idMap = new Map()

      data.forEach(obj => {
        if (idMap.has(obj.case_id)) {
          if (idMap.get(obj.case_id).length === 1) {
            idMap.get(obj.case_id)[0].repeated = true
          }
          idMap.get(obj.case_id).push({ ...obj, repeated: true })
        } else {
          idMap.set(obj.case_id, [{ ...obj, repeated: false }])
        }
      })

      return idMap
    },
    resumeAllCases() {
      this.$swal({
        title: 'Are you sure?',
        text: 'It will resume All the processes.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, resume all!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.value) {
          this.loader = true
          const cases = this.stuckCasesData.map(e => e.case_id)
          // eslint-disable-next-line no-unneeded-ternary
          const repeated = this.selectedTab === 'duplicate' ? true : false
          await axios.post('/process/resume-stuck-cases', { cases, fixRepeated: repeated })
            .then(response => {
              this.getStuckCases(this.selectedTab)
              this.$swal({
                icon: 'success',
                title: 'All the processes added to the queue.',
                text: response.data.message,
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              })
            })
          this.loader = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.query-input{
  padding: 0px
}

.search_by_select .vs__dropdown-toggle{
  width: 160px;
}
</style>
